import { useDispatch, useSelector } from "react-redux";
import * as nodeUtils from "../../../abstract/controller/utils/nodeUtils";
import { isNonEmptyString, isNullish } from "../../../abstract/controller/utils/systemUtils";
import { getStatusDraggedWithId, isStatusDragged } from "../../../abstract/redux/slice/statusSlice";
import {
  handleChoiceCreate,
  handleParameterCreate,
} from "../../../abstract/redux/slice/structureSlice";
import IconPlusCircled from "../../../themes/icons/IconPlusCircled";
import { ButtonDefault } from "../../ui/buttons/ButtonDefault";
import styles from "./ParameterOptions.module.scss";
import { getIsFolded } from "../../../abstract/redux/slice/metaSlice";

function ParameterOptions({ node }) {
  const _dispatch = useDispatch();

  const _id = nodeUtils.getID(node);
  const _uuid = nodeUtils.getUUID(node);
  const _name = nodeUtils.getName(node);

  const _isFolded = useSelector(getIsFolded(_uuid));
  const _isDragged = useSelector(getStatusDraggedWithId(_id));

  const _idTarget = nodeUtils.getIdTarget(node);
  const _defaultValue = nodeUtils.getValueDefault(node);

  if (_isFolded || _idTarget || !isNullish(_defaultValue) || isStatusDragged(_isDragged)) {
    return null;
  }

  const _hasChildrenChoices = nodeUtils.hasChoices(node);
  const _hasChildrenParameters = nodeUtils.hasParameters(node);
  const _hasChildren = nodeUtils.hasChildren(node);

  const handleButtonAddChoice = () => {
    setTimeout(async () => {
      _dispatch(handleChoiceCreate(_id));
    }, 500);
  };

  const handleButtonAddParameter = () => {
    setTimeout(async () => {
      _dispatch(handleParameterCreate(_id, true));
    }, 500);
  };

  if (_hasChildrenParameters || !isNonEmptyString(_name)) {
    return null;
  }

  if (!_hasChildren && _isDragged) {
    return null;
  }

  if (!_hasChildren) {
    return (
      <div className={`${styles["options"]}`}>
        <div className={styles["options__action"]}>
          <ButtonDefault text={"add\nchoice"} handler={handleButtonAddChoice} shadow />
          <ButtonDefault text={"add\nparameter"} handler={handleButtonAddParameter} shadow />
        </div>
      </div>
    );
  }

  return (
    <div className={`${styles["options"]} ${styles["options--invisible"]}`}>
      <div className={`${styles["options__icon"]}`}>
        <IconPlusCircled />
      </div>
      <div className={`${styles["options__action"]} ${styles["options__action--invisible"]}`}>
        {_hasChildrenChoices && (
          <ButtonDefault text={"add\nchoice"} handler={handleButtonAddChoice} shadow />
        )}
      </div>
    </div>
  );
}

export default ParameterOptions;
